var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1325 20.44C38.1325 18.55 36.61 17.5 34.4575 17.5C32.2 17.5 30.6775 18.6025 30.6775 20.4925L31.2388 40.8353C31.288 42.6176 32.6648 43.9993 34.4478 43.9994V43.9994C36.2369 43.9995 37.6212 42.6093 37.6624 40.8207L38.1325 20.44ZM30.625 51.6775C30.625 53.83 32.2525 55.4575 34.3525 55.4575C36.6625 55.4575 38.185 53.725 38.185 51.6775C38.185 49.63 36.6625 47.845 34.3525 47.845C32.2525 47.845 30.625 49.525 30.625 51.6775Z",
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61.4375H5C4.24508 61.4375 3.76239 60.633 4.11765 59.9669L34.1176 3.71691C34.4941 3.01103 35.5059 3.01103 35.8824 3.71691L65.8823 59.9669C66.2376 60.633 65.7549 61.4375 65 61.4375Z",
    stroke: "#868E96",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3b4f60c31dba1a24069df5c29e3b4485.svg";
export { ForwardRef as ReactComponent };